// External dependencies
import React, { ChangeEvent } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// Local dependencies
import formatMessage from '../../../intl/formatMessage';
import { RootState } from '../../../redux/store';
import {
  listConsigneeProfiles,
  setConsigneeProfileField,
} from '../../consignee-profiles/redux/actions';
import AsyncSelect from '../../custom-select/NewAsyncSearch';
import { ConsigneeProfile } from '../../consignee-profiles/redux/reducer';
import { setCreateConsigneeGoodField } from './redux/actions';

interface Service {
  id: string;
  title: string;
}

export default React.memo(function SelectConsigneeProfile() {
  const dispatch = useDispatch();

  const { consigneeProfiles, loading, searchString } = useSelector(
    (state: RootState) => state.consigneeProfiles,
  );

  const preparedItems = consigneeProfiles?.map(
    (consigneeProfile: ConsigneeProfile) => ({
      id: consigneeProfile.id,
      title: consigneeProfile.name,
    }),
  );

  function onSearch(e: ChangeEvent<HTMLInputElement>) {
    dispatch(listConsigneeProfiles(e.target.value));
  }

  function onClear() {
    dispatch(listConsigneeProfiles(''));
  }

  function onSelectService(data: Service) {
    const { id, title } = data;

    const preparedConsigneeProfile: ConsigneeProfile = {
      id,
      name: title,
    };

    dispatch(setConsigneeProfileField('searchString', title));

    dispatch(
      setCreateConsigneeGoodField('consigneeProfile', preparedConsigneeProfile),
    );
  }

  return (
    <div>
      <AsyncSelect
        items={preparedItems}
        loading={loading}
        onSearch={onSearch}
        searchString={searchString}
        searchPlaceholder={formatMessage('findConsigneeProfile')}
        onClear={onClear}
        onSelectItem={onSelectService}
      />
    </div>
  );
});
